import Cookies from 'js-cookie';

export default class CookieBar {
  constructor({ el }) {
    this.el = el;
    this.acceptButton = this.el.querySelector('.accept');
    this.rejectButton = this.el.querySelector('.reject');

    this.init();
  }

  init() {
    // if cookie consent has not been set, show the cookie bar
    if (!Cookies.get('june-cookie-consent')) {
      this.el.classList.add('active');

      // if the user accepts cookies, set the cookie and hide the cookie bar
      this.acceptButton.addEventListener('click', () => {
        Cookies.set('june-cookie-consent', 'accept', { expires: 365 });
        document.body.classList.add('cookies-accepted');
        this.el.classList.remove('active');
      });

      // if the user rejects cookies, set the cookie to reject and hide the cookie bar
      this.rejectButton.addEventListener('click', () => {
        Cookies.set('june-cookie-consent', 'reject', { expires: 365 });
        this.el.classList.remove('active');
      });
    }
  }
}
